<template>
  <v-card flat>
    <!-- Cabeçalho com informações do paciente -->
    <v-layout v-if="dadosPaciente" wrap justify-center class="white-background">
      <v-card outlined class="mx-4 mt-2">
        <v-row>
          <!-- Coluna 1: Avatar e Nome -->
          <v-col cols="12" sm="6" md="4">
            <v-list dense class="pb-0 mb-0">
              <v-list-item>
                <v-list-item-avatar>
                  <v-img src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png" aspect-ratio="1" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ dadosPaciente.paciente }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip class="ma-2" color="grey darken-3" label small text-color="white">
                      <v-icon left>mdi-label</v-icon>
                      {{ dadosPaciente.atendimento }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <!-- Coluna 2: Dados Pessoais -->
          <v-col cols="12" sm="6" md="4">
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Data de Nascimento: <strong>{{ dadosPaciente.dataNascimento }}</strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Idade: <strong>{{ dadosPaciente.idade }}</strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Sexo: <strong>{{ dadosPaciente.sexo }}</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <!-- Coluna 3: Dados Adicionais -->
          <v-col cols="12" sm="12" md="4">
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Cidade: <strong>{{ dadosPaciente.cidade }}</strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Convênio: <strong>{{ dadosPaciente.convenio }}</strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Solicitante: <strong>{{ dadosPaciente.solicitante }}</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </v-layout>

    <!-- Corpo Principal -->
    <v-card flat class="pa-4">
      <v-row>
        <!-- Informações Laterais (Detalhes do Laudo) -->
        <v-col v-if="selectedLaudo" cols="12" md="4">
          <v-card class="pa-2 mb-2" outlined>
            <div class="text-subtitle-2 font-weight-bold mb-2">Detalhes do Laudo</div>
            <v-divider class="mb-2" />
            <v-container class="pa-0">
              <v-row dense>
                <v-col cols="12">
                  <strong>Exame:</strong> {{ selectedLaudo.nomeExame }}
                </v-col>
                <v-col cols="6">
                  <strong>Data:</strong> {{ formatDate(selectedLaudo.dataRegistro) }}
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <v-card v-if="selectedLaudo.obsLaudoTec" class="pa-2 mb-2" outlined>
            <div class="text-subtitle-2 font-weight-bold mb-2">Observação do Técnico</div>
            <v-divider class="mb-2" />
            <v-card-text class="pa-0">
              {{ selectedLaudo.obsLaudoTec }}
            </v-card-text>
          </v-card>

          <v-card class="pa-2 mb-2" outlined>
            <div class="text-subtitle-2 font-weight-bold mb-2">Arquivos Disponíveis</div>
            <v-divider class="mb-2" />
            <v-list dense>
              <v-list-item v-for="(file, index) in imagens" :key="index" @click="abrirArquivo(file)">
                <v-list-item-content>
                  <v-list-item-title class="text-truncate">
                    <a>Arquivo: {{ index + 1 }}</a>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>{{ getFileIcon(file) }}</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- Lista de Laudos ou Editor de Laudo -->
        <v-col :cols="selectedLaudo ? 8 : 12">
          <v-card v-if="!selectedLaudo">
            <v-tabs v-model="tab" background-color="grey lighten-4" centered>
              <v-tab href="#liberados">
                <v-icon left>mdi-check</v-icon>
                Laudos Liberados
              </v-tab>
              <v-tab href="#abertos">
                <v-icon left>mdi-pencil</v-icon>
                Laudos Abertos
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <!-- Laudos Liberados -->
              <v-tab-item value="liberados">
                <!-- Campo de Busca para Laudos Liberados -->
                <v-text-field
                  v-model="buscaLiberados"
                  label="Buscar por nome do paciente"
                  outlined
                  dense
                  class="ma-4"
                  prepend-inner-icon="search"
                  clearable
                ></v-text-field>

                <v-card flat height="75vh" style="overflow-y: auto;">
                  <v-list>
                    <v-list-item
                      v-for="(consulta, index) in laudosLiberadosFiltrados"
                      :key="'liberado-' + index"
                      @click="selectLaudo(consulta)"
                      class="mb-2"
                      outlined
                    >
                      <v-card outlined class="w-100">
                        <v-row align="center" no-gutters>
                          <!-- Ícone de Laudo -->
                          <v-col cols="auto" class="ml-2">
                            <v-icon color="primary">mdi-file-document</v-icon>
                          </v-col>

                          <!-- Conteúdo do Laudo -->
                          <v-col>
                            <span class="font-weight-bold mx-4">{{ consulta.apelidoExame }}</span>
                            <v-card-subtitle>
                              <div>
                                <strong>Paciente:</strong> {{ consulta.nomePaciente }}
                              </div>
                              <div>
                                <strong>Data:</strong> {{ formatDate(consulta.dataRegistro) }}
                              </div>
                              <div>
                                {{ consulta.obsLaudoTec || 'Sem observações' }}
                              </div>
                            </v-card-subtitle>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-list-item>
                  </v-list>
                  <v-alert dense type="info" v-show="laudosLiberadosFiltrados.length === 0">
                    Sem laudos liberados
                  </v-alert>
                </v-card>
              </v-tab-item>

              <!-- Laudos Abertos -->
              <v-tab-item value="abertos">
                <!-- Campo de Busca para Laudos Abertos -->
                <v-text-field
                  v-model="buscaAbertos"
                  label="Buscar por nome do paciente"
                  outlined
                  dense
                  prepend-inner-icon="search"
                  class="ma-4"
                  clearable
                ></v-text-field>

                <v-card flat height="75vh" style="overflow-y: auto;">
                  <v-list>
                    <v-list-item
                      v-for="(consulta, index) in laudosAbertosFiltrados"
                      :key="'aberto-' + index"
                      @click="selectLaudo(consulta)"
                      class="mb-2"
                      outlined
                    >
                      <v-card outlined class="w-100">
                        <v-row align="center" no-gutters>
                          <!-- Ícone de Laudo -->
                          <v-col cols="auto" class="ml-2">
                            <v-icon color="primary">mdi-file-document</v-icon>
                          </v-col>

                          <!-- Conteúdo do Laudo -->
                          <v-col>
                            <span class="font-weight-bold mx-4">{{ consulta.apelidoExame }}</span>
                            <v-card-subtitle>
                              <div>
                                <strong>Paciente:</strong> {{ consulta.nomePaciente }}
                              </div>
                              <div>
                                <strong>Data:</strong> {{ formatDate(consulta.dataRegistro) }}
                              </div>
                              <div>
                                {{ consulta.obsLaudoTec || 'Sem observações' }}
                              </div>
                            </v-card-subtitle>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-list-item>
                  </v-list>
                  <v-alert dense type="info" v-show="laudosAbertosFiltrados.length === 0">
                    Sem laudos abertos
                  </v-alert>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>

          <!-- Editor de Laudo -->
          <v-card v-else outlined>
            <laudo :userAux="user" :paciente="selectedLaudo" :consulta="selectedLaudo" @voltar="voltarLaudo" />
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service'
import laudo from '../../components/editorDeTexto/laudo.vue'

export default {
  components: {
    laudo
  },
  data () {
    return {
      user: null,
      load: false,
      todosLaudosLiberados: [],
      todosLaudosAbertos: [],
      imagens: [],
      selectedLaudo: null,
      isAddLaudo: false,
      dadosPaciente: null,
      tab: 'liberados', // Aba padrão
      buscaLiberados: '', // Campo de busca para Laudos Liberados
      buscaAbertos: '' // Campo de busca para Laudos Abertos
    }
  },
  computed: {
    laudosLiberadosFiltrados () {
      return this.filtrarLaudosPorPaciente(this.todosLaudosLiberados, this.buscaLiberados)
    },
    laudosAbertosFiltrados () {
      return this.filtrarLaudosPorPaciente(this.todosLaudosAbertos, this.buscaAbertos)
    }
  },
  watch: {
    selectedLaudo (val) {
      if (val) {
        this.retornarInformacoesPacienteOs(val.idOS)
      }
    }
  },
  methods: {
    abrirArquivo (file) {
      window.open(file, '_blank')
    },
    getFileIcon (file) {
      return file.toLowerCase().endsWith('.pdf') ? 'mdi-file-pdf-box' : 'mdi-image'
    },
    voltarLaudo () {
      this.isAddLaudo = false
      this.selectedLaudo = null
      this.dadosPaciente = null
      this.buscaLiberados = ''
      this.buscaAbertos = ''
    },
    selectLaudo (laudo) {
      this.selectedLaudo = laudo
      this.imagens = Array.isArray(laudo.files) ? laudo.files : []
      this.buscarLaudos(laudo.idExamesOS)
    },
    formatDate (date) {
      return new Date(date).toLocaleDateString('pt-BR')
    },
    buscarLaudos (idExamesOS) {
      medicoService.medico.listarLaudosTecByIdsExamesOs([idExamesOS]).then((r) => {
        if (r.status === 200) {
          const laudo = Array.isArray(r.data) ? r.data[0] : r.data
          this.imagens = laudo && Array.isArray(laudo.files) ? laudo.files : this.imagens
        }
      })
    },
    filtrarLaudosPorPaciente (laudos, busca) {
      const termo = (busca || '').trim().toLowerCase()
      if (!termo) {
        return laudos
      }

      return laudos.filter((consulta) => {
        return (consulta.nomePaciente || '').toLowerCase().includes(termo)
      })
    },
    listarLaudosTec () {
      this.load = true
      Promise.all([
        medicoService.medico.listarLaudosTec(this.user.idPrestador, 'A', this.user.id),
        medicoService.medico.listarLaudosTec(this.user.idPrestador, 'X', this.user.id),
        medicoService.medico.listarLaudosTec(this.user.idPrestador, 'L', this.user.id)
      ]).then(([preSalvos, abertos, liberados]) => {
        const abertosResults = []
        if (preSalvos.status === 200 && preSalvos.data.status) {
          abertosResults.push(...preSalvos.data.results)
        }
        if (abertos.status === 200 && abertos.data.status) {
          abertosResults.push(...abertos.data.results)
        }
        this.todosLaudosAbertos = abertosResults
        if (liberados.status === 200 && liberados.data.status) {
          this.todosLaudosLiberados = liberados.data.results
        }
      }).finally(() => {
        this.load = false
      })
    },
    retornarInformacoesPacienteOs (idExamesOS) {
      medicoService.medico.retornarInformacoesPacienteOs(idExamesOS).then((r) => {
        if (r.status === 200) {
          this.dadosPaciente = r.data
        }
      })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.listarLaudosTec()
  }
}
</script>

<style scoped>
.white-background {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}

.v-list-item {
  cursor: pointer;
}

.w-100 {
  width: 100%;
}
</style>
